import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfCtaText, sfCtaUrl, sfHeadline, sfImage, sfSub } from './sectionHelpers';

const ParallaxSection: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const overlayOpacity = c.overlay_opacity || 'medium';

  const overlayAlpha =
    overlayOpacity === 'light' ? 0.3 :
    overlayOpacity === 'dark'  ? 0.7 : 0.5;

  const sectionStyle: React.CSSProperties = {
    position: 'relative',
    backgroundImage: sfImage(c) ? `url(${sfImage(c)})` : 'none',
    backgroundColor: sfImage(c) ? undefined : '#1a365d',
    backgroundAttachment: 'fixed',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '120px 24px',
    color: '#fff',
    textAlign: 'center',
  };

  return (
    <section className="sb-render sb-render-parallax-section" style={sectionStyle}>
      {/* Overlay */}
      <div style={{
        position: 'absolute',
        inset: 0,
        background: `rgba(0,0,0,${overlayAlpha})`,
        pointerEvents: 'none',
      }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 800, margin: '0 auto' }}>
        <InlineEditText
          tag="h2"
          controlKey="headline"
          style={{ fontSize: '3rem', fontWeight: 800, lineHeight: 1.1, marginBottom: 16, letterSpacing: '-0.025em', color: '#fff' }}
        >
          {sfHeadline(c, 'Bold Headline Over Image')}
        </InlineEditText>

        <InlineEditText
          tag="p"
          controlKey="subheadline"
          style={{ fontSize: '1.25rem', opacity: 0.9, marginBottom: 16 }}
        >
          {sfSub(c, 'A compelling subheadline goes here')}
        </InlineEditText>

        {c.body && (
          <InlineEditText
            tag="p"
            controlKey="body"
            style={{ fontSize: '1rem', opacity: 0.8, marginBottom: 32, maxWidth: 600, margin: '0 auto 32px' }}
          >
            {c.body}
          </InlineEditText>
        )}

        {(sfCtaText(c) || sfCtaUrl(c)) && (
          <a
            href={sfCtaUrl(c)}
            className="sb-cta-btn"
            style={{
              display: 'inline-block',
              padding: '16px 36px',
              borderRadius: 'var(--brand-btn-radius, 6px)',
              background: 'var(--brand-primary, #2563eb)',
              color: '#fff',
              fontWeight: 700,
              textDecoration: 'none',
              fontSize: '1rem',
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
              transition: 'transform 0.2s, box-shadow 0.2s',
            }}
          >
            <InlineEditText tag="span" controlKey="cta_text">
              {sfCtaText(c, 'Learn More')}
            </InlineEditText>
          </a>
        )}
      </div>
    </section>
  );
};

export default ParallaxSection;
